import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Overview } from "@curves/ui-shared";
import { isValidDate, parseDate } from "@Util/moment.util";

const DISPLAY_DATE_BY_SLASH = "YYYY/MM/DD";

const headerRow = [
	{
		cellKey: "reportDate",
		headerLabel: "回報日期",
		align: "center",
		formatCell: value => (value ? parseDate(value, DISPLAY_DATE_BY_SLASH) : "—"),
	},
	{ cellKey: "employeeName", headerLabel: "回報人" },
	{ cellKey: "reportReason", headerLabel: "回報原因" },
	{
		cellKey: "processDate",
		headerLabel: "處理日期",
		align: "center",
		formatCell: value => (isValidDate(value) ? parseDate(value, DISPLAY_DATE_BY_SLASH) : <span className="text-error">處理中</span>),
	},
	{ cellKey: "processTypeName", headerLabel: "處理類型" },
	{ cellKey: "processorName", headerLabel: "處理人" },
	{ cellKey: "processReason", headerLabel: "處理原因" },
];

const ShopStockDefectRecords = ({ overviewData, updateOverviewPage, className = "" }) => {
	const contextValue = useMemo(() => ({ overviewData, updateOverviewPage }), [overviewData, updateOverviewPage]);

	return (
		<Overview contextValue={contextValue} idKey="clubDefectiveReportID" className={className}>
			<Overview.TotalCount className="text-right mb-2" showCurrentCount />
			<Overview.Table headerRow={headerRow} className="mb-3" tableClassName="theme-gray" />
			<Overview.Pagination />
		</Overview>
	);
};

ShopStockDefectRecords.propTypes = {
	overviewData: PropTypes.shape({
		list: PropTypes.array,
		pagination: PropTypes.shape({
			pageIndex: PropTypes.number,
			totalPage: PropTypes.number,
			totalCount: PropTypes.number,
		}),
	}),
	updateOverviewPage: PropTypes.func,
	className: PropTypes.string,
};

export default ShopStockDefectRecords;
